import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    q: '¿Y si me despierto igual a las 3AM la primera noche?',
    a: 'Normal. El cuerpo tarda 2–3 noches en responder. Para eso existe el Template 3. No te rindas antes del día 3.'
  }, {
    q: '¿Puedo hacer solo algunos templates?',
    a: 'Sí, pero el sistema funciona mejor completo. Si solo puedes hacer uno, empieza con el Template 1 esta noche.'
  }, {
    q: '¿Los ingredientes del té realmente están en el Oxxo?',
    a: 'Manzanilla en bolsita: sí. Manzana y canela: Oxxo, Walmart o cualquier tiendita de barrio. Total: $50 MXN máximo.'
  }, {
    q: '¿Y si tomo medicamento para dormir?',
    a: 'Consulta a tu médico antes de combinar. Esta guía es apoyo de hábitos, no medicamento. Muchas mujeres la usan en paralelo con supervisión médica.'
  }, {
    q: '¿Funciona si tengo menopausia activa?',
    a: 'Sí. Fue diseñada específicamente para los cambios hormonales que ocurren después de los 45.'
  }, {
    q: '¿En qué formato recibo la guía?',
    a: 'Digital — descarga inmediata en PDF. Puedes imprimirla o usarla directo en tu celular o tablet.'
  }, {
    q: '¿Qué pasa si en 5 noches no veo diferencia?',
    a: 'Revisa el Template 7 — "Qué NO Hacer". En la mayoría de los casos, hay uno o más errores activos que bloquean los resultados.'
  }];
  return <section className="py-20 px-4 md:px-8 bg-cream-100 text-navy-900" data-id="element-86">
      <div className="max-w-3xl mx-auto" data-id="element-87">
        <div className="text-center mb-12" data-id="element-88">
          <span className="text-4xl mb-4 block" data-id="element-89">❓</span>
          <h2 className="text-gold-600 font-bold tracking-widest uppercase text-sm mb-2" data-id="element-90">
            SECCIÓN 10 — PREGUNTAS FRECUENTES
          </h2>
        </div>

        <div className="space-y-4" data-id="element-91">
          {faqs.map((faq, index) => <div key={index} className="bg-white rounded-lg shadow-sm border border-cream-200 overflow-hidden" data-id="element-92">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-93">
                <span className={`font-bold text-lg ${openIndex === index ? 'text-gold-600' : 'text-navy-900'}`} data-id="element-94">
                  {faq.q}
                </span>
                {openIndex === index ? <ChevronUp className="h-5 w-5 text-gold-500" data-id="element-95" /> : <ChevronDown className="h-5 w-5 text-navy-400" data-id="element-96" />}
              </button>

              <AnimatePresence data-id="element-97">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-98">
                    <div className="px-6 pb-6 text-navy-700 font-body leading-relaxed border-t border-cream-100 pt-4" data-id="element-99">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}